import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router/router'
import store from './store/store'
import Notifications from 'vue-notification'

import Study from "@/utilities/study.js";

import InfoPopover from '@/components/info-popover/InfoPopover.vue';
import SubjectLink from '@/components/subject/SubjectLink.vue';
import SubjectHistoryForms from "@/components/subject/SubjectHistoryForms.vue";
import Multiselect from 'vue-multiselect'
Vue.config.productionTip = false

Vue.use(Notifications);

Vue.mixin(Study);

Vue.component('InfoPopover', InfoPopover)
Vue.component('SubjectLink', SubjectLink);
Vue.component('SubjectHistoryForms', SubjectHistoryForms);
// register globally
Vue.component('multiselect', Multiselect)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
